import React, { useEffect, useState, useCallback } from "react";
import alumniApi from "../../config/alumniApi";
import styles from "./AlumniPages.module.css";

const AlumniDirectory = () => {
  const [filters, setFilters] = useState({ q: "", city: "", employment_status: "" });
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  const search = useCallback(() => {
    setLoading(true);
    alumniApi
      .get("/alumni/directory", { params: { ...filters, page } })
      .then(({ data }) => setResults(data.results))
      .finally(() => setLoading(false));
  }, [filters, page]);

  useEffect(() => {
    const timer = setTimeout(search, 300); // debounce
    return () => clearTimeout(timer);
  }, [search]);

  return (
    <div>
      <h1 className={styles.heading}>Alumni Directory</h1>
      <p className={styles.subheading}>Search and reconnect with fellow Pratibha Poshak alumni.</p>

      <div className={styles.filterBar}>
        <input
          className={styles.input}
          placeholder="Search by name, company, designation"
          value={filters.q}
          onChange={(e) => {
            setPage(1);
            setFilters((f) => ({ ...f, q: e.target.value }));
          }}
        />
        <input
          className={styles.input}
          placeholder="City"
          value={filters.city}
          onChange={(e) => {
            setPage(1);
            setFilters((f) => ({ ...f, city: e.target.value }));
          }}
        />
        <select
          className={styles.select}
          value={filters.employment_status}
          onChange={(e) => {
            setPage(1);
            setFilters((f) => ({ ...f, employment_status: e.target.value }));
          }}
        >
          <option value="">All employment statuses</option>
          <option value="EMPLOYED">Employed</option>
          <option value="SELF_EMPLOYED">Self-Employed</option>
          <option value="STUDENT">Studying</option>
          <option value="UNEMPLOYED">Unemployed</option>
        </select>
      </div>

      {loading && <div className={styles.emptyState}>Searching...</div>}

      {!loading && results.length === 0 && (
        <div className={styles.emptyState}>No alumni found matching your filters.</div>
      )}

      {!loading &&
        results.map((a) => (
          <div className={styles.card} key={a.alumni_id}>
            <div className={styles.cardName}>{a.student_name}</div>
            <div className={styles.cardMeta}>
              {[a.designation, a.company_name].filter(Boolean).join(" at ") || "—"}
            </div>
            <div className={styles.cardMeta}>
              {[a.city, a.state, a.country].filter(Boolean).join(", ")}
            </div>
            {a.cohort_name && <span className={styles.badge}>{a.cohort_name}</span>}
            {a.linkedin_url && (
              <div style={{ marginTop: 8 }}>
                <a href={a.linkedin_url} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: "#1f3a6e" }}>
                  View LinkedIn →
                </a>
              </div>
            )}
          </div>
        ))}

      <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
        <button className={styles.button} disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
          Previous
        </button>
        <button className={styles.button} onClick={() => setPage((p) => p + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default AlumniDirectory;
